import { useEffect, useRef } from 'react';

function useModalHistory(onClose) {
  useEffect(() => {
    const previous = window.history.state;
    window.history.pushState({ ...(previous || {}), dopeManBoardModal: true }, '', window.location.href);
    let popped = false;
    const handlePop = (event) => {
      if (event.state?.dopeManBoardModal) return;
      popped = true;
      onClose();
    };
    window.addEventListener('popstate', handlePop);
    return () => {
      window.removeEventListener('popstate', handlePop);
      if (!popped && window.history.state?.dopeManBoardModal) {
        window.history.replaceState(previous, '', window.location.href);
      }
    };
  }, [onClose]);
}

export function BulletinBoardModal({ post, onClose }) {
  const modalRef = useRef(null);
  const closeRef = useRef(null);
  useModalHistory(onClose);
  useEffect(() => {
    closeRef.current?.focus();
    const handleKey = (event) => {
      if (event.key === 'Escape') { onClose(); return; }
      if (event.key !== 'Tab') return;
      const focusable = [...(modalRef.current?.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex=\"-1\"])') || [])]
        .filter((element) => !element.disabled && element.getAttribute('aria-hidden') !== 'true');
      if (!focusable.length) { event.preventDefault(); return; }
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    };
    window.addEventListener('keydown', handleKey);
    return () => window.removeEventListener('keydown', handleKey);
  }, [onClose]);
  const date = post.publishAt ? new Date(post.publishAt).toLocaleString() : '';
  return (
    <div className="board-modal-backdrop" role="presentation" onMouseDown={(event) => { if (event.target === event.currentTarget) onClose(); }}>
      <section ref={modalRef} className="board-modal" role="dialog" aria-modal="true" aria-labelledby="board-modal-title">
        <span className="board-modal-category">{String(post.category || 'notice').toUpperCase()}{post.pinned ? ' · PINNED' : ''}</span>
        <h2 id="board-modal-title">{post.title}</h2>
        <p className="board-modal-body">{post.body}</p>
        <footer><span>{post.author || 'The Dope Man System'}</span>{date && <time dateTime={post.publishAt}>{date}</time>}</footer>
        <button ref={closeRef} type="button" className="board-modal-close" onClick={onClose}>Put the note back</button>
      </section>
    </div>
  );
}
